export default class Configuration {
  static get CONFIG() {
    return {
      VUE_APP_ADMIN_API_BASE_URL: '_VUE_APP_ADMIN_API_BASE_URL_',
      VUE_APP_AUTH_API_BASE_URL: '_VUE_APP_AUTH_API_BASE_URL_',
      VUE_APP_INFO_API_BASE_URL: '_VUE_APP_INFO_API_BASE_URL_',
    };
  }

  static value(key: string) {
    if (!(key in this.CONFIG)) {
      console.warn(`Configuration: There is no key named "${key}"`);
      return;
    }

    const value = (this.CONFIG as any)[key];

    if (value === undefined) {
      console.warn(`Configuration: Value for "${key}" is not defined`);
      return;
    }

    if (value.startsWith('_VUE_APP_')) {
      // development mode
      // Remove _ and get current value from process.env
      const envName = value.substr(1, value.length - 2);
      const envValue = process.env[envName];
      if (envValue !== undefined) {
        return envValue;
      } else {
        console.warn(`Configuration: Environment variable "${envName}" is not defined`);
      }
    } else {
      return value;
    }
  }
}
